/**
 * Product Sticky Cart
 * SP専用の追従カートとバリアント選択パネル
 */

class ProductStickyCart {
  constructor() {
    this.stickyCart = document.querySelector('[data-sticky-cart]');
    this.originalCartButton = document.querySelector('.product-form__submit[type="submit"]');
    this.productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    
    if (!this.stickyCart || !this.originalCartButton || !this.productForm) {
      return;
    }
    
    this.init();
  }

  init() {
    // スクロール監視
    this.observeScroll();
    
    // 追従カートのボタンクリックでパネルを開く（modal.js使用）
    const stickyCartBtn = this.stickyCart.querySelector('[data-sticky-cart-button]');
    if (stickyCartBtn) {
      stickyCartBtn.addEventListener('click', () => {
        if (window.modalSystem) {
          window.modalSystem.open('sticky-cart__info-container');
          // パネルを開いたときにメインの選択状態を同期
          this.syncMainToPanel();
        }
      });
    }
    
    // パネル内のカートボタン
    const panel = document.getElementById('sticky-cart__info-container');
    if (panel) {
      const panelCartBtn = panel.querySelector('[data-sticky-cart-add-to-cart]');
      if (panelCartBtn) {
        panelCartBtn.addEventListener('click', () => this.addToCart());
      }
      
      // パネル内のバリアント選択変更を監視
      const panelVariantSelects = panel.querySelector('variant-selects');
      if (panelVariantSelects) {
        panelVariantSelects.addEventListener('change', () => {
          this.syncPanelToMain();
        });
      }
    }
    
    // バリアント変更時に追従カートのボタン状態を同期
    this.observeVariantChange();
    
    // 初期表示時も同期
    this.syncStickyCartButton();
  }

  observeVariantChange() {
    if (typeof subscribe !== 'function') {
      this.observeButtonChanges();
      return;
    }
    
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      this.syncStickyCartButton();
      this.updateStickyCartPrice(event.data.variant);
    });
  }
  
  updateStickyCartPrice(variant) {
    if (!variant) return;
    
    // スティッキーカート内の価格要素を更新
    const priceElement = document.querySelector('.sticky-cart__price .price__current');
    const compareElement = document.querySelector('.sticky-cart__price .price__compare');
    
    if (priceElement) {
      priceElement.innerHTML = window.formatPrice(variant.price);
    }
    
    if (compareElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareElement.innerHTML = window.formatPrice(variant.compare_at_price);
        compareElement.style.display = '';
      } else {
        compareElement.style.display = 'none';
      }
    }
  }
  
  observeButtonChanges() {
    const observer = new MutationObserver(() => {
      this.syncStickyCartButton();
    });
    
    if (this.originalCartButton) {
      observer.observe(this.originalCartButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }
  
  syncStickyCartButton() {
    const stickyBtn = this.stickyCart.querySelector('[data-sticky-cart-button]');
    const panel = document.getElementById('sticky-cart__info-container');
    const panelBtn = panel ? panel.querySelector('[data-sticky-cart-add-to-cart]') : null;
    
    if (!this.originalCartButton) return;
    
    const isDisabled = this.originalCartButton.hasAttribute('disabled');
    
    if (stickyBtn) {
      if (isDisabled) {
        stickyBtn.setAttribute('disabled', '');
      } else {
        stickyBtn.removeAttribute('disabled');
      }
    }
    
    if (panelBtn) {
      if (isDisabled) {
        panelBtn.setAttribute('disabled', '');
      } else {
        panelBtn.removeAttribute('disabled');
      }
    }
    
    const originalSpan = this.originalCartButton.querySelector('span');
    
    if (originalSpan) {
      const content = originalSpan.innerHTML.replace(/<span class="loading__spinner[^>]*>.*?<\/span>/s, '');
      
      if (stickyBtn) {
        const stickySpan = stickyBtn.querySelector('span');
        if (stickySpan) {
          stickySpan.innerHTML = content;
        }
      }
      
      if (panelBtn) {
        const panelSpan = panelBtn.querySelector('span');
        if (panelSpan) {
          panelSpan.innerHTML = content;
        }
      }
    }
  }

  observeScroll() {
    let ticking = false;
    
    const checkPosition = () => {
      const rect = this.originalCartButton.getBoundingClientRect();
      const isBelow = rect.bottom < 0;
      
      if (isBelow) {
        this.stickyCart.classList.add('is-visible');
      } else {
        this.stickyCart.classList.remove('is-visible');
      }
      
      ticking = false;
    };
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(checkPosition);
        ticking = true;
      }
    });
    
    // 初期チェック
    checkPosition();
  }

  // メインの選択状態をパネルに同期
  syncMainToPanel() {
    const mainVariantSelects = document.querySelector('variant-selects');
    const panel = document.getElementById('sticky-cart__info-container');
    
    if (!mainVariantSelects || !panel) return;
    
    const panelVariantSelects = panel.querySelector('variant-selects');
    if (!panelVariantSelects) return;
    
    // メインで選択されているオプション値IDを取得
    const mainSelectedInputs = mainVariantSelects.querySelectorAll('input[type="radio"]:checked');
    
    mainSelectedInputs.forEach(mainInput => {
      const optionValueId = mainInput.getAttribute('data-option-value-id');
      if (!optionValueId) return;
      
      // パネル内で同じoption-value-idを持つラジオボタンを選択
      const panelInput = panelVariantSelects.querySelector(
        `input[type="radio"][data-option-value-id="${optionValueId}"]`
      );
      
      if (panelInput) {
        panelInput.checked = true;
      }
    });
  }
  
  // パネルの選択状態をメインに同期
  syncPanelToMain() {
    const mainVariantSelects = document.querySelector('variant-selects');
    const panel = document.getElementById('sticky-cart__info-container');
    
    if (!mainVariantSelects || !panel) return;
    
    const panelVariantSelects = panel.querySelector('variant-selects');
    if (!panelVariantSelects) return;
    
    // パネルで選択されているオプション値IDを取得
    const panelSelectedInputs = panelVariantSelects.querySelectorAll('input[type="radio"]:checked');
    
    panelSelectedInputs.forEach(panelInput => {
      const optionValueId = panelInput.getAttribute('data-option-value-id');
      if (!optionValueId) return;
      
      // メイン内で同じoption-value-idを持つラジオボタンを選択
      const mainInput = mainVariantSelects.querySelector(
        `input[type="radio"][data-option-value-id="${optionValueId}"]`
      );
      
      if (mainInput && !mainInput.checked) {
        mainInput.checked = true;
        // changeイベントを発火してメインの他の処理（価格更新など）をトリガー
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  addToCart() {
    this.syncPanelToForm();
    
    if (this.originalCartButton) {
      this.originalCartButton.click();
    }
    
    if (window.modalSystem) {
      window.modalSystem.close('sticky-cart__info-container');
    }
  }
  
  syncPanelToForm() {
    const panel = document.getElementById('sticky-cart__info-container');
    if (!panel) return;
    
    const panelQuantity = panel.querySelector('.quantity__input');
    const formQuantity = this.productForm.querySelector('.quantity__input');
    
    if (panelQuantity && formQuantity) {
      formQuantity.value = panelQuantity.value;
      formQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    const panelVariantInputs = panel.querySelectorAll('input[name="id"]');
    const formVariantInput = this.productForm.querySelector('input[name="id"]');
    
    panelVariantInputs.forEach(input => {
      if (input.checked && formVariantInput) {
        formVariantInput.value = input.value;
        formVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const countElements = document.querySelectorAll('[data-cart-count]');
      countElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

// 初期化 - より確実に実行
function initProductStickyCart() {
  // modal.jsが読み込まれるまで待機
  if (typeof window.modalSystem === 'undefined') {
    setTimeout(initProductStickyCart, 100);
    return;
  }
  
  new ProductStickyCart();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductStickyCart);
} else {
  initProductStickyCart();
}
